import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import HoobuySpreadsheetArticle from "../pages/article-hoobuyspreadsheet/page";
import GuiaIniciantesHoobuy from "../pages/guia-iniciantes-hoobuy/page";
import VerificarLinksHoobuy from "../pages/verificar-links-hoobuy/page";
import TopProdutosHoobuy2026 from "../pages/top-produtos-hoobuy-2026/page";
import ComparacaoAgentesHoobuy from "../pages/comparacao-agentes-hoobuy/page";
import GuiaTamanhosHoobuy from "../pages/guia-tamanhos-hoobuy/page";
import ErrosComunsHoobuy from "../pages/erros-comuns-hoobuy/page";
import DicasEnvioInternacional from "../pages/dicas-envio-internacional/page";
import FaqHoobuySpreadsheet from "../pages/faq-hoobuy-spreadsheet/page";
import HistoriasSucessoHoobuy from "../pages/historias-sucesso-hoobuy/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/hoobuyspreadsheet",
    element: <HoobuySpreadsheetArticle />,
  },
  {
    path: "/guia-iniciantes-hoobuy",
    element: <GuiaIniciantesHoobuy />,
  },
  {
    path: "/verificar-links-hoobuy",
    element: <VerificarLinksHoobuy />,
  },
  {
    path: "/top-produtos-hoobuy-2026",
    element: <TopProdutosHoobuy2026 />,
  },
  {
    path: "/comparacao-agentes-hoobuy",
    element: <ComparacaoAgentesHoobuy />,
  },
  {
    path: "/guia-tamanhos-hoobuy",
    element: <GuiaTamanhosHoobuy />,
  },
  {
    path: "/erros-comuns-hoobuy",
    element: <ErrosComunsHoobuy />,
  },
  {
    path: "/dicas-envio-internacional",
    element: <DicasEnvioInternacional />,
  },
  {
    path: "/faq-hoobuy-spreadsheet",
    element: <FaqHoobuySpreadsheet />,
  },
  {
    path: "/historias-sucesso-hoobuy",
    element: <HistoriasSucessoHoobuy />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;